var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"imageLink"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.contents.content.link}},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":_vm.image}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }